<div class="flex flex-col gap-8">
  <div class="relative flex flex-col h-[480px]">
    <div class="flex-1 bg-white dark:bg-zinc-800 rounded-2xl shadow-xl p-8 pb-20 border border-zinc-100 dark:border-zinc-700">
      <div class="flex items-center mb-6">
        <div [ngClass]="config.bgColor" class="p-3 rounded-full mr-4 w-12 h-12 flex items-center justify-center">
          <i [ngClass]="[config.icon, config.iconColor]" class="text-2xl"></i>
        </div>
        <h3 class="text-2xl font-bold text-gray-800 dark:text-white">
          {{ config.title }}
        </h3>
      </div>

      <div class="min-h-[280px] flex flex-col">
        <p-fileupload
          #fileUpload
          [name]="config.title + '[]'"
          [multiple]="false"
          accept=".xlsx,.xls"
          maxFileSize="10000000"
          (onSelect)="onFileSelected($event)"
          [showUploadButton]="false"
          [showCancelButton]="false"
          [auto]="false"
          [disabled]="jobRunning"
          class="flex-1"
        >
          <ng-template #content let-files>
            <div
              *ngIf="!selectedFile"
              class="flex items-center justify-center flex-col p-12 border-3 border-dashed border-blue-300 dark:border-blue-600 rounded-xl hover:border-blue-500 dark:hover:border-blue-400 hover:bg-blue-50 dark:hover:bg-blue-900/20 transition-all duration-300 group h-[180px]"
              [class.cursor-pointer]="!jobRunning"
              [class.opacity-50]="jobRunning"
              (click)="!jobRunning && fileUpload.choose()"
              [pTooltip]="jobRunning ? 'Veuillez attendre la fin du traitement en cours' : ''"
              tooltipPosition="top"
            >
              <div class="bg-green-500 p-4 rounded-full mb-6 w-12 h-12 flex items-center justify-center">
                <i class="pi pi-file-arrow-up text-3xl text-white"></i>
              </div>
              <p class="text-lg font-semibold text-gray-700 dark:text-gray-200 mb-2">
                Glissez et déposez votre fichier Excel ici
              </p>
              <p class="text-sm text-gray-500 dark:text-gray-400">
                ou cliquez pour sélectionner (.xlsx, .xls)
              </p>
              <div class="mt-4 px-6 py-2 bg-blue-100 dark:bg-blue-900 text-blue-700 dark:text-blue-300 rounded-full text-sm font-medium">
                Taille max: 10MB
              </div>
            </div>
            <div
              *ngIf="selectedFile"
              class="p-6 border-2 border-green-200 dark:border-green-700 rounded-xl bg-gradient-to-r from-green-50 to-emerald-50 dark:from-green-900/20 dark:to-emerald-900/20"
            >
              <div class="flex gap-4 w-full">
                <div class="bg-green-100 dark:bg-green-800 p-3 rounded-full w-12 h-12 flex items-center justify-center">
                  <i class="pi pi-file-excel text-2xl text-green-600 dark:text-green-400"></i>
                </div>
                <div class="flex-1">
                  <p class="font-bold text-gray-800 dark:text-white text-lg">
                    {{ selectedFile.name }}
                  </p>
                  <p class="text-sm text-gray-600 dark:text-gray-300">
                    {{ formatSize(selectedFile.size) }}
                  </p>
                  <div class="flex items-center mt-2">
                    <i class="pi pi-check-circle text-green-500 dark:text-green-400 mr-2"></i>
                    <span class="text-sm text-green-600 dark:text-green-400 font-medium">Fichier prêt</span>
                  </div>
                </div>
                <p-button
                  icon="pi pi-times"
                  (click)="removeFile()"
                  [outlined]="true"
                  [rounded]="true"
                  severity="danger"
                  size="small"
                />
              </div>
            </div>
          </ng-template>
          <ng-template #file></ng-template>
        </p-fileupload>
      </div>

      <p-button
        [label]="isSending ? 'Envoi en cours...' : (jobRunning ? 'Envoi en cours...' : 'Envoyer ' + config.title)"
        [icon]="isSending || jobRunning ? 'pi pi-spin pi-spinner' : 'pi pi-send'"
        [disabled]="!selectedFile || jobRunning || isSending"
        (click)="sendFile()"
        [pTooltip]="(jobRunning || isSending) ? 'Veuillez attendre la fin du traitement en cours' : ''"
        tooltipPosition="top"
        class="text-lg font-semibold absolute bottom-6 right-6"
      />
    </div>
  </div>

  <div *ngIf="showStatus" class="bg-white dark:bg-zinc-800 rounded-2xl shadow-xl p-8 border border-gray-100 dark:border-gray-700">
    <div class="flex items-center mb-6">
      <div [ngClass]="config.bgColor" class="p-3 rounded-full mr-4 w-12 h-12 flex items-center justify-center">
        <i [ngClass]="[config.icon, config.iconColor]" class="text-2xl"></i>
      </div>
      <h3 class="text-2xl font-bold text-gray-800 dark:text-white">Statut - {{ config.title }}</h3>
      <div class="ml-auto flex items-center">
        <i *ngIf="jobRunning" class="pi pi-spin pi-spinner text-blue-500 dark:text-blue-400 mr-2 text-xl"></i>
        <i *ngIf="!jobRunning && result?.ErrorCount === 0" class="pi pi-check-circle text-green-500 dark:text-green-400 mr-2 text-xl"></i>
        <i *ngIf="!jobRunning && (result?.ErrorCount ?? 0) > 0" class="pi pi-exclamation-triangle text-red-500 dark:text-red-400 mr-2 text-xl"></i>
      </div>
    </div>
    <div *ngIf="jobRunning" class="p-6 mb-3 border-2 rounded-xl border-blue-200 dark:border-blue-700 bg-blue-50 dark:bg-blue-900/20">
      <div class="flex items-center justify-center py-8">
        <i class="pi pi-spin pi-spinner text-blue-500 dark:text-blue-400 text-3xl mr-3"></i>
        <p class="text-lg text-gray-700 dark:text-gray-300">Traitement en cours...</p>
      </div>
    </div>
    <div *ngIf="!jobRunning && !result" class="p-6 border-2 rounded-xl border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-900/20">
      <div class="flex items-center justify-center py-8">
        <i class="pi pi-info-circle text-gray-500 dark:text-gray-400 text-3xl mr-3"></i>
        <p class="text-lg text-gray-700 dark:text-gray-300">Aucun traitement en cours</p>
      </div>
    </div>
    <div *ngIf="result" class="p-6 border-2 rounded-xl" [ngClass]="result.ErrorCount > 0 ? 'border-red-200 dark:border-red-700 bg-red-50 dark:bg-red-900/20' : 'border-green-200 dark:border-green-700 bg-green-50 dark:bg-green-900/20'">
      <div class="grid grid-cols-3 gap-4 mb-4">
        <div class="text-center p-4 bg-white dark:bg-zinc-700 rounded-lg">
          <p class="text-2xl font-bold text-gray-800 dark:text-white">{{ result.TotalProcessed }}</p>
          <p class="text-sm text-gray-600 dark:text-gray-300 mt-1">Total traité</p>
        </div>
        <div class="text-center p-4 bg-white dark:bg-zinc-700 rounded-lg">
          <p class="text-2xl font-bold text-green-600 dark:text-green-400">{{ result.SuccessCount }}</p>
          <p class="text-sm text-gray-600 dark:text-gray-300 mt-1">Succès</p>
        </div>
        <div class="text-center p-4 bg-white dark:bg-zinc-700 rounded-lg">
          <p class="text-2xl font-bold text-red-600 dark:text-red-400">{{ result.ErrorCount }}</p>
          <p class="text-sm text-gray-600 dark:text-gray-300 mt-1">Erreurs</p>
        </div>
      </div>
        <!-- Warning Card for Errors -->
        <div *ngIf="result && result.ErrorCount > 0" class="bg-red-50 dark:bg-red-900/20 p-2">
          <div class="flex items-center">
            <div class="bg-red-100 dark:bg-red-800 p-3 rounded-full mr-4 w-12 h-12 flex items-center justify-center">
              <i class="pi pi-exclamation-triangle text-2xl text-red-600 dark:text-red-400"></i>
            </div>
            <div class="flex-1">
              <h4 class="text-lg font-bold text-red-800 dark:text-red-300 mb-1">Action requise</h4>
              <p class="text-red-700 dark:text-red-400">Veuillez corriger toutes les erreurs avant de continuer le traitement.</p>
            </div>
          </div>
        </div>
      <div *ngIf="result.ErrorCount > 0" class="mt-4 p-4 bg-red-100 dark:bg-red-900/30 rounded-lg">
        <p class="font-semibold text-red-800 dark:text-red-300 mb-2">Erreurs détectées:</p>
        <ul class="list-disc list-inside text-sm text-red-700 dark:text-red-400 space-y-1 max-h-48 overflow-y-auto">
          <li *ngFor="let error of result.ErrorMessages">{{ error }}</li>
        </ul>
      </div>
    </div>
  </div>


</div>
